<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path fill="#000" d="M6 5h4v14H6V5zM14 5h4v14h-4V5z"/>
</svg>
